/**
 * Takes in a duration in string format with a time unit and returns the raw
 * number value
 *
 * @param duration - The duration in string format with unit (e.g. '350ms')
 * @param [unit='ms'] - The time unit included in the duration string (e.g. 'ms')
 * @returns The number value of the duration
 */
export const durationStringToNumber = (duration: string, unit = 'ms') =>
    Number(duration.replace(unit, ''))
